module.exports = __webpack_public_path__ + "img/bus.e84ddc3e.svg";